module.exports = __webpack_public_path__ + "static/media/ad2.99496c28.png";